
import Constant from "@constant/index.js";
import Intercept from "@observer/Intercept.js";

export default class SubscribeView{
    constructor(model){
        this._model = model;
        this._model._view = this;
        this._parentEl = this._model._parent._view._headerBoxEl;
        this._el = null;
    }

    render(){
        let html = "";
        if(this._model._leftTime && (this._model._parent._parent._itemType != Constant.GROUP_TYPE.PACKAGE.TYPE)){
            html += `<div class="good_item_head" tag='subscribe'>
                <span class="item le_tag">${this._model._name}</span>
                <span class="item"><span tag='subscribedesc'>${this._model._desc}</span>&nbsp;<span class="le_color_red" tag='subscribeleft'>${this._model._leftTime}</span></span>
                ${this._model._isCanScribe?'<span tag="goBooking" class="item le_color_red"><a href="'+this._model._parent._link+'">去预约</a><i class="iconfont icon-arrow-right le_vertical_align_m"></i></span>':''}
            </div>`
            // $(this._parentEl).prepend($(html));
            $(this._parentEl).append($(html));
            this._el = $(this._parentEl).find("[tag='subscribe']");
            this.interceptList();
        }
    }

    interceptList(){
        let time = $(this._el).find("[tag=subscribeleft]");
        new Intercept().init(time, this._model, "_leftTime");

        let desc = $(this._el).find("[tag=subscribedesc]");
        new Intercept().init(desc, this._model, "_desc");

        //checked
        let checkedEl = $(this._el).find("[tag=goBooking]");
        new Intercept().init(checkedEl, this._model, "_isCanScribe", 'show');
    }
}